import { useMemo } from 'react';
import { useUserTenantPreference } from 'kineticUtils/hooks';
import { PREFERENCE_KEYS } from 'types/preferenceTypes';

export interface ClusteringPreference {
  clusteringEnabled: boolean;
}

export const useClusteringState = () => {
  const {
    value: { clusteringEnabled = true },
  } = useUserTenantPreference<ClusteringPreference>({
    key: PREFERENCE_KEYS.MAP_CLUSTERING,
  });

  const contextValue = useMemo(
    () => ({
      clusteringEnabled,
    }),
    [clusteringEnabled]
  );

  return contextValue;
};
